import React, { useEffect, useRef, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { mainProduct_fetchItems_user } from "../../API/Service/mainProductService";
import LoadingSpinner from "../loader/LoadingSpinner";
import CategoryCard from "../User/Cards/CategoryCard";
import Testimonial from "../User/Testimonial/Testimonial";
import ShipDetail from "../User/Shipping/ShipDetail";
import BannerSlider from "../User/Slider/BannerSlider";
import { useNavigate } from "react-router-dom";
import { isSmallScreen } from "../../MIS/Global";
import { encrypt } from "../../MIS/encryption";
import BrandSection from "../Home/BrandSection";

const Home = () => {
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const { userMainProducts, mainProductLoading, mainProductCount } = useSelector((state) => state.mainproduct);
  let productBgColor="";
  const sectionRef = useRef(null); // Reference to the specific section

  useEffect(() => {
    document.cookie = "unused=mis@123";
    // document.cookie = "unused=mis@123; path=/; SameSite=None";
    mainProduct_fetchItems_user({ last_id: 0, limit: 100 }, dispatch);
  }, []);
  
  return (
    <Container fluid>
      {/* Image Slider Section */}
      
      <Row className="mb-4">
        <Col xs={12}>
          <BannerSlider />
        </Col>
      </Row>

      {/* Specific Section for Main Scroll */}
      {/* <Row>
        <Col xs={12} className="mb-4" style={{ padding: "0" }} ref={sectionRef}>
          {userMainProducts?.map((product, index) => {
            // Determine if the category name has changed
            let shouldPrintCategory =userMainProducts[userMainProducts.length - 1].catgname !== product.catgname;
            if(mainProductCount === userMainProducts.length){shouldPrintCategory=true;}
            if(productBgColor==""){
              productBgColor="#f3e6f8";
            }else if(productBgColor=="#f3e6f8"){
              productBgColor="#f9e2d4";
            }else if(productBgColor=="#f9e2d4"){
              productBgColor="#f7f5c1";
            }else if(productBgColor=="#f7f5c1"){
              productBgColor="#f3e6f8";
            }
            // Alternate row background color when the category changes
            const rowBackgroundColor = productBgColor;

            return (
              <Container
                key={product?.catgid}
                fluid
                style={{
                  backgroundColor: rowBackgroundColor,
                  padding:isSmallScreen()?"10px":"40px",
                  marginBottom: "20px",
                }}
              >
                {shouldPrintCategory && (
                  <Row className="mb-4">
                    <Col xs={12}>
                      <h2>{product.catgname}</h2>
                    </Col>
                  </Row>
                )}
                <Row className="gx-1 gy-1 gx-md-3 gy-md-3">
                  {[...(product?.products || [])]
                    ?.sort((a, b) => a.seqno - b.seqno)?.map((element) => (
                    <Col key={element?.id} xs={6} sm={6} md={4} lg={3} >
                      <CategoryCard product={element} path={`/subcategory/${encrypt(element?.id)}/${element?.productName}`}/>
                    </Col>
                  ))}
                </Row>
              </Container>
            );
          })}
        </Col>
      </Row> */}

      <Row>
        <Col xs={12} className="mb-4" style={{ padding: "0" }} ref={sectionRef}>
          {userMainProducts?.map((product) => (
            <div key={product?.catgid} 
            style={{ marginBottom: "20px",padding:'10px' }}>
              
              {/* ===== Banner Slider ===== */}
              <Row className="mb-2">
                <Col xs={12} className="">
                  <BrandSection
                    title={product.catgname}
                    products={product?.products || []}  
                    isSection="home"                  
                  />
                </Col>
              </Row>             
            </div>
          ))}
        </Col>
      </Row>

      {/* Loading Spinner */}
      <Col xs={12} className="d-flex justify-content-center align-items-center">
        <LoadingSpinner isLoading={mainProductLoading} />
      </Col>

      {/* Additional Sections */}
      <Row className="mb-4 d-none">
        <Col xs={12}>
          <ShipDetail />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col xs={12}>
          <Testimonial />
        </Col>
      </Row>
      
    </Container>
  );
};

export default Home;
